module.exports = __webpack_public_path__ + "img/21.9eae8149.png";